export interface SkeletonProps {
  variant?: "text" | "title" | "card" | "avatar";
  width?: string;
  height?: string;
  className?: string;
}

/**
 * Skeleton shimmer loading placeholder in multiple variants.
 */
export function Skeleton({
  variant = "text",
  width,
  height,
  className = "",
}: SkeletonProps) {
  return (
    <div
      className={`skeleton skeleton--${variant} ${className}`}
      style={{ width, height }}
      aria-hidden="true"
    />
  );
}

/**
 * Skeleton card for dashboard/template loading states.
 */
export function SkeletonCard() {
  return (
    <div className="card" style={{ overflow: "hidden" }}>
      <Skeleton variant="card" height="8rem" />
      <div style={{ padding: "var(--z-space-5)", display: "flex", flexDirection: "column", gap: "var(--z-space-3)" }}>
        <Skeleton variant="title" width="70%" />
        <Skeleton variant="text" width="40%" />
        <Skeleton variant="text" width="55%" />
      </div>
    </div>
  );
}
